export class DeliveryLocationClass {
  #locationDisplaySelector = "#js-location-display";

  #locationCache = new Map();

  constructor() {
    this.init();
  }

  get #$locationDisplay() {
    return document.querySelector(this.#locationDisplaySelector);
  }

  init() {
    this.#handleInitialDisplay();
    this.#setupEventListener();
  }

  #handleInitialDisplay() {
    const $locationDisplay = this.#$locationDisplay;
    if ($locationDisplay && $locationDisplay.textContent.includes("Loading")) {
      $locationDisplay.classList.remove("animate-pulse");
      $locationDisplay.textContent = "Location";
    }
  }

  #setupEventListener() {
    document.addEventListener("location-data-updated", event => {
      const { zipcode, locationData } = event.detail;
      this.#handleLocationUpdate(zipcode, locationData);
    });
  }

  #handleLocationUpdate(zipcode, locationData) {
    if (!zipcode || zipcode.length !== 5) return;

    const cached = this.#locationCache.get(zipcode);
    if (cached) {
      this.#updateLocationDisplay(cached.city, cached.state);
      return;
    }

    if (locationData?.error) {
      this.#showErrorState();
      this.#locationCache.delete(zipcode);
      return;
    }

    if (locationData) {
      const { city, state } = DeliveryLocationClass.#extractLocationFromResponse(locationData);

      if (city && state) {
        this.#locationCache.set(zipcode, { city, state });
        this.#updateLocationDisplay(city, state);
      } else {
        this.#updateLocationDisplay(null, null);
      }
    }
  }

  #updateLocationDisplay(city, state) {
    const $locationDisplay = this.#$locationDisplay;
    if (!$locationDisplay) return;

    $locationDisplay.classList.remove("animate-pulse");
    $locationDisplay.textContent = city && state ? `${city}, ${state}` : "Location";
  }

  #showErrorState() {
    const $locationDisplay = this.#$locationDisplay;
    if (!$locationDisplay) return;

    $locationDisplay.classList.remove("animate-pulse");
    $locationDisplay.textContent = "Invalid zipcode";
  }

  static #extractLocationFromResponse(response) {
    if (!response?.cities?.length) return { city: null, state: null };

    const { name: city, state_code: state } = response.cities[0];
    return { city, state };
  }
}

export default () => new DeliveryLocationClass();
